import { isEmpty, isNull } from 'lodash'

export const formatDateString = (dateTimeStamp) => {
  const date = new Date(dateTimeStamp)

  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  })

  const formattedDate = date
    .toLocaleDateString('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    })
    .replace(',', ' •')

  return `${formattedTime} • ${formattedDate}`
}

export const isNullOrMissing = (value) => {
  return isNull(value) || isEmpty(value) || value === 'None'
}

export const moment_type_mapping = {
  note: {
    srcUrl:
      'https://res.cloudinary.com/openhouse-study/image/upload/v1748947153/assets/moment%20observation%20icons/chat%20icons/Icon-Type_Note_Color_Orange.png',
    label: 'Note',
    meSrcUrl:
      'https://res.cloudinary.com/openhouse-study/image/upload/v1748982202/assets/moment%20observation%20icons/chat%20icons/white/Icon-Type_Note_Color_Orange.png'
  },
  nap: {
    srcUrl:
      'https://res.cloudinary.com/openhouse-study/image/upload/v1748947150/assets/moment%20observation%20icons/chat%20icons/Icon-Type_Nap_Color_Orange.png',
    label: 'Nap Update',
    meSrcUrl:
      'https://res.cloudinary.com/openhouse-study/image/upload/v1748982200/assets/moment%20observation%20icons/chat%20icons/white/Icon-Type_Nap_Color_Orange.png'
  },
  toilet: {
    srcUrl:
      'https://res.cloudinary.com/openhouse-study/image/upload/v1748947154/assets/moment%20observation%20icons/chat%20icons/Icon-Type_Toilet_Color_Orange.png',
    label: 'Toilet Update',
    meSrcUrl:
      'https://res.cloudinary.com/openhouse-study/image/upload/v1748982699/assets/moment%20observation%20icons/chat%20icons/white/Icon-Type_Toilet_Color_Orange.png'
  },
  food: {
    srcUrl:
      'https://res.cloudinary.com/openhouse-study/image/upload/v1748947150/assets/moment%20observation%20icons/chat%20icons/Icon-Type_Food_Color_Orange.png',
    label: 'Food Update',
    meSrcUrl:
      'https://res.cloudinary.com/openhouse-study/image/upload/v1748982197/assets/moment%20observation%20icons/chat%20icons/white/Icon-Type_Food_Color_Orange.png'
  },
  photo_video: {
    label: 'Media Update'
  }
}
